const colors = {
  dark: "#000000",
  white: "#FCFCFC",
  darkGrey: "#0F0F0F",
  overlay: "rgba(0, 0, 0, 0.3)",
};

export default colors;
